/**
 * Dashboard Filter Bar
 * Global filter controls for date range and competitor selection
 */
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Filter, Check } from 'lucide-react';
import { useDashboardFilters } from '@/contexts/DashboardFilters';
import { cn } from '@/lib/utils';
import { useCompset } from '@/contexts/CompsetContext';

export default function FilterBar({ className }) {
  const {
    selectedCompetitors,
    toggleCompetitor,
    clearCompetitorFilters,
  } = useDashboardFilters();

  const [competitorMenuOpen, setCompetitorMenuOpen] = useState(false);

  const { activeCompset } = useCompset();
  // const hasActiveFilters = selectedCompetitors.length > 0 ;

  return (
    <div className='flex'>
      {activeCompset && activeCompset?.competitors?.length > 0 && (
        <Popover open={competitorMenuOpen} onOpenChange={setCompetitorMenuOpen}>
          <PopoverTrigger asChild>
            <Button variant="solid" size="sm" className="h-8 gap-2">
              <Filter className="h-3.5 w-3.5" />
              {/* <span className="text-xs">Competitors</span> */}
              {selectedCompetitors.length > 0 && (
                <Badge variant="secondary" className="ml-1 h-4 px-1 text-xs">
                  {selectedCompetitors.length}
                </Badge>
              )}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-64 p-0" align="start">
            <div className="p-2 border-b border-border">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium">Filter Competitors</span>
                {selectedCompetitors.length > 0 && (
                  <Button
                    variant="ghost"
                    size="sm"
                    className="h-6 text-xs"
                    onClick={clearCompetitorFilters}
                  >
                    Clear
                  </Button>
                )}
              </div>
            </div>
            <div className="max-h-64 overflow-y-auto p-2 space-y-1">
              {activeCompset?.competitors.map((comp) => {
                const isSelected = selectedCompetitors.includes(comp.competitor_id || comp.id);
                return (
                  <button
                    key={comp.competitor_id || comp.id}
                    className={cn(
                      'w-full flex items-center justify-between px-3 py-2 text-sm rounded-md transition-colors',
                      'hover:bg-accent',
                      isSelected && 'bg-primary/10 text-primary'
                    )}
                    onClick={() => toggleCompetitor(comp.competitor_id || comp.id)}
                  >
                    <span className="truncate">{comp?.name || comp.short_name}</span>
                    {isSelected && <Check className="h-4 w-4 flex-shrink-0" />}
                  </button>
                );
              })}
            </div>
          </PopoverContent>
        </Popover>
      )}

      {/* Active Filters Summary */}
      {/* {hasActiveFilters && (
        <>
          <div className="h-4 w-px bg-border" />
          <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground">Active:</span>
            {selectedCompetitors.length > 0 && (
              <Badge variant="secondary" className="gap-1">
                {selectedCompetitors.length} competitor{selectedCompetitors.length > 1 ? 's' : ''}
                <X
                  className="h-3 w-3 cursor-pointer hover:text-destructive"
                  onClick={clearCompetitorFilters}
                />
              </Badge>
            )}
            {timeRangePreset === 'custom' && (
              <Badge variant="secondary">Custom dates</Badge>
            )}
          </div>
        </>
      )} */}

      {/* Reset All */}
      {/* {hasActiveFilters && (
        <Button
          variant="ghost"
          size="sm"
          className="h-8 gap-2 ml-auto"
          onClick={resetFilters}
        >
          <X className="h-3.5 w-3.5" />
          <span className="text-xs">Reset All</span>
        </Button>
      )} */}
    </div>
  );
}

